export default __webpack_public_path__ + "static/media/Contacts.d5ff4166.svg";